import { useAuth, useClerk } from "@clerk/clerk-react";
import { Link, Navigate, Outlet } from "react-router";
import { Button } from "@web/components/ui/button.tsx";
import { ClerkTokenBridge } from "./ClerkTokenBridge.tsx";

/**
 * Layout route: signed-out → `/sign-in`; signed-in → token bridge + child routes.
 * Loading / stuck session always offers a way out.
 */
export function RequireAuth() {
  const { isLoaded, isSignedIn } = useAuth();
  const { signOut } = useClerk();

  if (!isLoaded) {
    return (
      <div className="flex h-full flex-col items-center justify-center gap-4 bg-bg p-6 text-center">
        <p className="text-sm text-muted">Loading session…</p>
        <Button variant="ghost" size="sm" asChild>
          <Link to="/sign-in">Open sign-in</Link>
        </Button>
      </div>
    );
  }

  if (!isSignedIn) {
    return <Navigate to="/sign-in" replace />;
  }

  return (
    <ClerkTokenBridge
      fallback={
        <div className="flex h-full flex-col items-center justify-center gap-4 bg-bg p-6 text-center">
          <p className="text-sm text-muted">Loading session…</p>
          <div className="flex flex-wrap items-center justify-center gap-2">
            <Button variant="ghost" size="sm" asChild>
              <Link to="/sign-in">Open sign-in</Link>
            </Button>
            <Button
              variant="ghost"
              size="sm"
              className="text-muted"
              onClick={() => void signOut({ redirectUrl: "/sign-in" })}
            >
              Sign out
            </Button>
          </div>
        </div>
      }
    >
      <Outlet />
    </ClerkTokenBridge>
  );
}
